import { render, staticRenderFns } from "./StaticAttachments.vue?vue&type=template&id=61e6e4fa"
import script from "./StaticAttachments.vue?vue&type=script&lang=js"
export * from "./StaticAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports